var _path, _path2, _path3, _g, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6037 22.2906C14.2405 24.7198 16.5262 26.5736 17.68 26.4977C17.7202 26.4949 22.0582 25.6614 24.4325 21.5714C26.2808 18.3891 25.6513 15.3165 23.1378 15.2498C22.2338 15.3175 12.3895 17.6617 13.6037 22.2906ZM15.7869 4.00002C14.15 4.00002 12.5963 4.35138 11.1909 4.97814C10.945 5.08121 10.7054 5.19884 10.4735 5.33041C10.3143 5.4155 10.1551 5.49968 10.0014 5.59118L10.038 5.60308C9.57228 5.92607 9.17152 6.30212 8.84304 6.73766C5.5921 11.0417 16.4877 14.1701 22.3125 14.1811C24.9934 16.1089 25.7455 8.75154 23.1269 6.70929C21.0838 4.956 18.4791 3.99458 15.7869 4.00002Z",
    fill: "#0E3CA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6924 6.52358C10.2193 8.68751 5.31129 10.2128 4.50427 9.9749L4.50061 9.96575L4.60126 9.77086C5.44448 8.18866 6.64193 6.82273 8.10016 5.77969C8.4021 5.56284 8.71503 5.36063 9.03802 5.17214C9.72334 4.78328 10.4279 4.75949 10.6594 4.75034C12.8444 4.7906 11.7034 6.50619 11.6915 6.52358",
    fill: "#5493F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4836_27799",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 11,
    width: 8,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.5002H10.5001V26.4995H3V11.5002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4836_27799)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4562 22.7398C10.566 23.4508 10.4535 26.2607 10.3053 26.4977C10.179 26.505 9.91364 26.5215 9.1478 26.0969C7.66179 25.2597 6.3679 24.1201 5.3497 22.7517C4.60483 21.7494 4.02134 20.6368 3.62037 19.4541C3.20762 18.2308 2.99806 16.948 3.00002 15.6569C2.99773 14.2376 3.25127 12.8295 3.74847 11.5002H3.7503C4.62869 12.6521 5.64432 13.6943 6.50715 14.8581C7.32972 15.9653 8.46064 17.7705 8.6903 18.1567C10.1195 20.5512 10.3473 22.0289 10.4562 22.7398Z",
    fill: "#5493F7"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 15.7896C27 17.3259 26.7072 18.7944 26.1774 20.1413C24.7866 21.6419 15.4062 17.949 15.3138 17.9087C14.031 17.3451 10.1258 15.6286 9.77357 12.933C9.26667 9.05534 17.1099 6.35248 20.5567 6.25C20.9693 6.25457 22.2274 6.26921 22.9603 6.86761C24.2312 7.9803 25.2492 9.35209 25.946 10.8908C26.6428 12.4295 27.0021 14.0996 27 15.7887V15.7896ZM18.7971 25.3814C19.358 23.3959 24.2623 21.361 25.3448 21.2512C25.4784 21.2374 25.5351 21.3317 25.4765 21.4397C24.3474 23.4929 22.6758 25.1838 20.6527 26.2799C19.6298 26.7758 18.5044 26.4144 18.7971 25.3814Z",
    fill: "#5493F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerra);
export default __webpack_public_path__ + "static/media/terra.9b3855dcfd5cf6457afcd76862388797.svg";
export { ForwardRef as ReactComponent };